import React from 'react';
import { WorkspaceMetricCard } from '../workflow/WorkflowWorkspacePrimitives';

export type MappingMetricTone = 'neutral' | 'success' | 'warning' | 'info';

export interface MappingMetricCardProps {
  label: React.ReactNode;
  value: React.ReactNode;
  supporting?: React.ReactNode;
  tone?: MappingMetricTone;
  dataTestId?: string;
}

/**
 * Metric card for mapping workspace summaries.
 *
 * Thin wrapper around WorkspaceMetricCard that exposes the mapping-domain
 * tone names and keeps card styling aligned with the rest of the workspace.
 */
export const MappingMetricCard: React.FC<MappingMetricCardProps> = ({
  label,
  value,
  supporting,
  tone = 'neutral',
  dataTestId,
}) => (
  <WorkspaceMetricCard
    label={label}
    value={value}
    supporting={supporting}
    tone={tone}
    dataTestId={dataTestId}
  />
);

export default MappingMetricCard;
